// Small WebAudio "success" chime — synthesized, no audio file to ship or maintain.
// Used to notify an operator that a relay's confirmed status actually changed (i.e. the device's
// own readback moved), not that a command was merely clicked/sent — see playSuccessChime callers.
let ctx = null;

function getContext() {
  if (ctx) return ctx;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  ctx = new AudioCtx();
  return ctx;
}

// Browsers block audio until a user gesture has occurred on the page — call this from any click
// handler (it doesn't need to be the one that later triggers the chime) to unlock playback early,
// so a chime fired later by a poll-driven state change (not a click) can actually be heard.
export function primeAudio() {
  const c = getContext();
  if (c && c.state === "suspended") c.resume();
}

// Two-note rising chime.
export function playSuccessChime() {
  const c = getContext();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const now = c.currentTime;
  [
    [880, now, 0.09],
    [1318.5, now + 0.09, 0.14],
  ].forEach(([freq, start, dur]) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.18, start + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    osc.connect(gain).connect(c.destination);
    osc.start(start);
    osc.stop(start + dur + 0.02);
  });
}

function tone(c, freq, start, dur, type, peak) {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(start);
  osc.stop(start + dur + 0.05);
}

// Soft bell — Live Monitor's "a status changed" sound (pump started/stopped, back to normal).
export function playTing() {
  const c = getContext();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const t = c.currentTime;
  tone(c, 1568, t, 1.1, "sine", 0.22);
  tone(c, 3920, t, 0.5, "sine", 0.06);
}

// Three sharp beeps, twice — Live Monitor's "something went bad" sound (fire alarm, tank LOW/HIGH).
export function playAlert() {
  const c = getContext();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const t = c.currentTime;
  for (let r = 0; r < 2; r++) {
    for (let i = 0; i < 3; i++) tone(c, 1046.5, t + r * 0.75 + i * 0.17, 0.12, "square", 0.09);
  }
}
